<script lang="ts">
  import type { ProjectConfig } from '../../modules/projects/project.interface';
  import { NavigationDrawer, List, ListItem } from 'svelte-materialify';
  import { push, location } from 'svelte-spa-router';

  export let projectConfig: ProjectConfig;

  interface MenuItem {
    title: string;
    slug: string;
  }

  const menuItems: MenuItem[] = [
    {
      title: 'Reports',
      slug: '/reports',
    },
    {
      title: 'Sources',
      slug: '/sources',
    },
    {
      title: 'Featured Items',
      slug: '/featured-items',
    },
    {
      title: 'Settings',
      slug: '/settings',
    },
    {
      title: 'Stats',
      slug: '/stats',
    },
    {
      title: 'Users',
      slug: '/users',
    },
    {
      title: 'Events',
      slug: '/events',
    },
  ];

  $: activeMenuItem = getActiveMenuItem($location);

  function openPage(menuItem: MenuItem) {
    push(getMenuItemPath(menuItem));
  }

  function getActiveMenuItem($location: string) {
    return (
      menuItems.find((menuItem) => $location.includes(getMenuItemPath(menuItem))) || null
    );
  }

  function isActiveMenuItem(menuItem: MenuItem, activeMenuItem: MenuItem | null) {
    return menuItem === activeMenuItem;
  }

  function getMenuItemPath(menuItem: MenuItem) {
    return `/project/${projectConfig.key}${menuItem.slug}`;
  }
</script>

<NavigationDrawer fixed>
  <List>
    {#each menuItems as menuItem}
      <ListItem
        on:click={() => openPage(menuItem)}
        active={isActiveMenuItem(menuItem, activeMenuItem)}
      >
        {menuItem.title}
      </ListItem>
    {/each}
  </List>
</NavigationDrawer>
